import { createSelector } from '@ngrx/store';

import { getInitState } from './main.selectors';

export const getAppStatus = createSelector(getInitState, (state) => state);
